var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#DADBEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5.00777C19.76 5.52973 18.9407 5.92895 18.0736 6.19004C17.6083 5.65494 16.9898 5.27567 16.3018 5.10353C15.6138 4.93139 14.8896 4.97469 14.2271 5.22758C13.5645 5.48046 12.9956 5.93072 12.5973 6.51746C12.199 7.1042 11.9905 7.79912 12 8.50822V9.28095C10.642 9.31616 9.29644 9.01499 8.08305 8.40425C6.86967 7.79351 5.82615 6.89217 5.04545 5.7805C5.04545 5.7805 1.95455 12.735 8.90909 15.826C7.31768 16.9062 5.42189 17.4479 3.5 17.3714C10.4545 21.235 18.9545 17.3714 18.9545 8.48504C18.9538 8.2698 18.9331 8.05509 18.8927 7.84368C19.6814 7.06592 20.2379 6.08396 20.5 5.00777Z",
    stroke: "#424895",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2ca9244166b14a75ca087004f4d7da44.svg";
export { ForwardRef as ReactComponent };